export const extConfig = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: true,
    link: true,
    emote: true,
    gif: {
        defaultWidth: 534,
        canAlign: true,
        defaultAlignment: 'center'
    },
    deviation: {
        defaultWidth: 534,
        maxWidth: 534,
        canAlign: true,
        canLink: true
    },
    allowUploads: false,
    daVideo: {
        canAlign: true,
        defaultWidth: 534,
        defaultHeight: 300
    },
    gallery: {
        maxWidth: 534,
        defaultWidth: 534,
        defaultAlignment: 'center',
        defaultGridItemWidth: 235,
        defaultGridItemHeight: 235,
        defaultLayout: 'grid',
        defaultTorpedoRowHeight: 150,
        defaultLayoutSpacing: 8,
        canAlign: true,
        canLink: true
    },
    anchor: true,
    spinner: false,
    blockDragging: true,
    blockquote: true,
    heading: true,
    hashtag: true,
    mention: true,
    paste: true,
    textAlignment: true,
    textColor: true,
    textFont: true,
    textHighlight: true,
    history: true,
    indent: {
        captureTab: true
    },
    muro: false,
    characterCount: false
};

//# sourceMappingURL=config.js.map